import React from 'react';
import { ScrollView, View } from 'react-native';
import { useTheme } from '@/context/ThemeContext';
import { useTranslation } from '@/hooks/useTranslation';
import Text from '@/components/Typography/Text';
import Icon from '@/components/Icon';
import Button from '@/components/Buttons/Button';
import { getCatalogPalette } from '@/components/Catalog/catalogPalette';

export default function BookmarksEmptyMagazine({ onStartChat, style }) {
  const { theme } = useTheme();
  const { t } = useTranslation();
  const palette = getCatalogPalette(theme);

  return (
    <ScrollView style={{ flex: 1 }} contentContainerStyle={{ padding: 24, paddingTop: 32, paddingBottom: 40, alignItems: 'center' }}>
      <View style={[{ width: '100%', maxWidth: 480, alignItems: 'center', padding: 24, gap: 12,
        borderRadius: 18, borderWidth: 1, borderColor: palette.border, backgroundColor: palette.surface }, style]}>
        <View style={{ width: 44, height: 44, borderRadius: 12, backgroundColor: palette.preview, alignItems: 'center', justifyContent: 'center' }}>
          <Icon name="bookmark" size={20} color={palette.icon} />
        </View>
        <Text size="l" weight="semibold" style={{ textAlign: 'center' }}>{t('pages.bookmarks.emptyMagazineHeadline')}</Text>
        <Text size="s" color="secondary" style={{ textAlign: 'center', lineHeight: 21 }}>{t('pages.bookmarks.emptyHint')}</Text>
        <Button text={t('pages.messages.actions.startNewChat')} prependIcon="plus" variant="secondary" size="medium" onPress={onStartChat}
          style={{ marginTop: 6, borderRadius: 10, backgroundColor: palette.ink }} textStyle={{ color: palette.onInk }} iconColor={palette.onInk} hoverBackgroundColor={palette.ink} />
      </View>
    </ScrollView>
  );
}
